/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_Cycle_To_LightInputs */

const cs_theme_cycle_to_light = /** @type {(inputs: Theme_Cycle_To_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systémový režim — přepnout na světlý`)
};

const en_theme_cycle_to_light = /** @type {(inputs: Theme_Cycle_To_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System mode — switch to light`)
};

/**
* | output |
* | --- |
* | "System mode — switch to light" |
*
* @param {Theme_Cycle_To_LightInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const theme_cycle_to_light = /** @type {((inputs?: Theme_Cycle_To_LightInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_Cycle_To_LightInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_theme_cycle_to_light(inputs)
	return cs_theme_cycle_to_light(inputs)
});